import PropTypes from 'prop-types'

import * as S from './styled'
import { Step } from '../../components/Step'
import { Client } from '../../components/Client'
import { Title, Description } from '../../styled'

const ClientsDesktop = ({ currentStep, customers, onSelectCustomer }) => {
  return (
    <Step step={2} currentStep={currentStep}>
      <Title>Escolha um cliente para compartilhar</Title>
      <Description>Escolha apenas um de seus clientes ativos para enviar o cupom</Description>

      <form>
        <ul>
          {
            (customers.length && customers.map((item, index) => (
              <S.Item key={index}>
                <S.RadioButtonLabel>
                  <S.RadioButton type="radio" name="rdClient" onClick={() => onSelectCustomer(item)} />
                  <Client name={item.customerName} projectName={item.projectName} />
                </S.RadioButtonLabel>
              </S.Item>
            )))
          }
        </ul>
      </form>
    </Step>
  )
}

ClientsDesktop.propTypes = {
  currentStep: PropTypes.number,
  customers: PropTypes.array,
  onSelectCustomer: PropTypes.func
}

ClientsDesktop.defaultProps = {
  customers: []
}

export default ClientsDesktop
